export enum RewardType {
  ERC_20 = 'ERC_20',
  NFT_NODE = 'NFT_NODE',
}

export enum ModeTheme {
  light = 'light',
  dark = 'dark',
}

export enum ReferralLevel {
  LEVEL_1 = 'LV1',
  LEVEL_2 = 'LV2',
}

export enum ProjectTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum ProjectThemeTabs {
  THEME = 'THEME',
  TEXT = 'TEXT',
  IMAGES = 'IMAGES',
}

export enum ProjectStageEnum {
  DRAFT = 'DRAFT',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
  VOTING = 'VOTING',
  DEPOSIT = 'DEPOSIT',
}

export enum ProjectApprovalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum ProjectFundingStatus {
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
  REFUND = 'REFUND',
}
